export class Application {}

export const application = new Application;